export const environment = {
  production: false
};

export const appConfig = {
  version: "11.0.0",
  termsVersion:"2",
  producerSalesThreshold:20,
  domain: "https://app.latourneedesproducteurs.com"
};

export const firebaseConfig = {
  apiKey: "AIzaSyBgSKfxDfPwQnkXYzp7hR52odtE5A5lymg",
  authDomain: "matournee-20bad.firebaseapp.com",
  databaseURL: "https://matournee-20bad.europe-west1.firebasedatabase.app/",
  collectionURL: "https://latourneedesproducteurs-test.firebaseio.com/",
  projectId: "matournee-20bad",
  storageBucket: "matournee-20bad.appspot.com",
  messagingSenderId: "221802723637",
  appId: "1:221802723637:web:df517451b98b3a7703347c",
  measurementId: "G-0M7WYYZDLD"
};

export const hereMapsConfig = {
  apiKey: "X0PMYJaYDkAw6ar--kd789Nu63meoCNjuQYgiSSiVLI"
};

export const locationIDConfig = {
  apiKey: "pk.e443581252303706b173475f2497ff51"
};
export const googleMapsConfig = {
  apiKey: "AIzaSyCfY3uQcyOVKHisMQ2IwSiOmD6R-18Of84"
};

export const facebookConfig = {
  appId: "171244247554156"
};

export const paymentConfig = {
  mangopay:{
    clientId: "latournee-prod",
    baseURL: "https://api.mangopay.com",
    paylineJS:"https://payment.payline.com/scripts/widget-min.js",
    paylineCSS:"https://payment.payline.com/styles/widget-min.css"  
  },
  paymentEnabled: true,
};

export const lydiaConfig = {
  url:'https://lydia-app.com'
}